// The user card (mockup b-usercard.png): the hover card on posts gets the big level emblem, the forum level bar with
// "389 / 548 EXP", the main character (as its owner shows it), the unlocked achievements, the stats (posts, topics,
// likes, guides) and "View profile". The profile page's card (hero) gets the emblem and the stats. All from the user
// already loaded (aetGamify): no request.
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import Link from 'flarum/common/components/Link';
import { t, ts, nf, gamifyOf, Emblem, ExpBar, Chip, Flag, Crest, empName, classGlyph, classKind, Medal, achName, ACH, ACH_TOTAL } from './ui';
export function CardSections(user, g) {
  const max = g.lv >= 50;
  const chip = g.chip;
  const medals = (g.medals || []).filter(m => ACH[m[0]]);
  return m("div", {
    className: "aet-uc"
  }, m("div", {
    className: "aet-uc__sec"
  }, m("div", {
    className: "aet-uc__lbl"
  }, m("span", null, ts('card_level', {
    tier: ts(`tier.${g.tier}`)
  })), m("span", {
    className: "aet-uc__num"
  }, max ? ts('max_level') : ts('exp_of', {
    into: nf(g.into),
    need: nf(g.need)
  }))), ExpBar(g.pct, 'lg')), chip ? m("div", {
    className: "aet-uc__sec"
  }, m("div", {
    className: "aet-uc__lbl"
  }, m("span", null, t('main_title')), m("span", {
    className: "aet-uc__aside"
  }, t('from_game'))), m("div", {
    className: "aet-uc__char"
  }, m("div", {
    className: `aet-portrait aet-portrait--sm aet-cls--${classKind(chip.job)}`
  }, classGlyph(chip.job, 28)), m("div", {
    className: "aet-uc__charinfo"
  }, Chip(chip), m("dl", {
    className: "aet-kv"
  }, chip.emp ? [m("dt", null, t('kingdom')), m("dd", null, Flag(chip.emp), " ", empName(chip.emp))] : null, chip.guild ? [m("dt", null, t('guild')), m("dd", null, Crest(chip.guild), " ", chip.guild.name)] : null)))) : null, medals.length ? m("div", {
    className: "aet-uc__sec"
  }, m("div", {
    className: "aet-uc__lbl"
  }, m("span", null, t('achievements')), m("span", {
    className: "aet-uc__num"
  }, ts('n_of', {
    count: medals.length,
    total: ACH_TOTAL
  }))), m("div", {
    className: "aet-uc__medals"
  }, medals.slice(0, 6).map(md => m("span", {
    className: "aet-uc__medal"
  }, Medal(md[0], md[1]), m("span", null, achName(md[0])))), medals.length > 6 ? m("span", {
    className: "aet-medals__more"
  }, "+", medals.length - 6) : null)) : null, Stats(user, g), m("div", {
    className: "aet-uc__acts"
  }, m(Link, {
    className: "Button Button--primary aet-uc__view",
    href: app.route('user.aetProgress', {
      username: user.slug()
    })
  }, m("i", {
    className: "icon fas fa-user",
    "aria-hidden": "true"
  }), " ", t('view_profile'))));
}
export function Stats(user, g) {
  const s = (n, key) => m("div", null, m("b", null, nf(n)), m("span", null, t(key)));
  return m("div", {
    className: "aet-uc__sec aet-uc__stats"
  }, s(user.commentCount(), 'stat_posts'), s(user.discussionCount(), 'stat_topics'), s(g.likes, 'stat_likes'), s(g.guides, 'stat_guides'));
}
export default function addUserCard() {
  extend(UserCard.prototype, 'profileItems', function (items) {
    const g = gamifyOf(this.attrs.user);
    if (!g) return;
    items.add('aetLevel', m("div", {
      className: "aet-uc__emblem"
    }, Emblem(g, 'xl')), 5);
  });
  extend(UserCard.prototype, 'view', function (vdom) {
    const user = this.attrs.user;
    const g = gamifyOf(user);
    if (!g || !vdom || !vdom.attrs) return;
    const popover = String(this.attrs.className || '').includes('UserCard--popover');
    vdom.attrs.className = `${vdom.attrs.className || ''} aet-ucard${popover ? ' aet-ucard--pop' : ' aet-ucard--hero'}`;
    // div.UserCard > div.darkenBackground > div.container > [profile, controls]
    const container = vdom.children && vdom.children[0] && vdom.children[0].children && vdom.children[0].children[0];
    if (!container || !Array.isArray(container.children)) return;
    container.children.push(popover ? CardSections(user, g) : m("div", {
      className: "aet-uc aet-uc--hero"
    }, Stats(user, g)));
  });
}
flarum.reg.add('aethernal-forum', 'forum/gamify/usercard', addUserCard);